import React from "react";

export const Email = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6407_90807)">
        <path
          d="M4.14231 4.30713C3.26581 4.30713 2.55469 5.01825 2.55469 5.89475C2.55469 6.39419 2.78952 6.86386 3.18974 7.16484L10.3869 12.5627C10.764 12.8439 11.28 12.8439 11.657 12.5627L18.8542 7.16484C19.2545 6.86386 19.4893 6.39419 19.4893 5.89475C19.4893 5.01825 18.7782 4.30713 17.9017 4.30713H4.14231ZM2.55469 8.01157V14.8913C2.55469 16.0588 3.50395 17.0081 4.67151 17.0081H17.3725C18.54 17.0081 19.4893 16.0588 19.4893 14.8913V8.01157L12.2921 13.4095C11.538 13.9751 10.506 13.9751 9.75189 13.4095L2.55469 8.01157Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6407_90807">
          <rect width="16.9346" height="16.9346" fill="white" transform="translate(2.55469 2.19043)" />
        </clipPath>
      </defs>
    </svg>
  );
};
